var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiAssistantEmptyAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3787 56.5785C49.7076 55.8256 58.7318 46.6733 59.4744 35.1837C59.6196 32.9353 59.6196 30.6066 59.4744 28.3582C58.7318 16.8686 49.7076 7.71643 38.3787 6.96336C34.5136 6.70644 30.4785 6.70698 26.6212 6.96336C15.2923 7.71643 6.26815 16.8686 5.5256 28.3582C5.3803 30.6066 5.3803 32.9353 5.5256 35.1837C5.79606 39.3684 7.64674 43.2429 9.82554 46.5146C11.0906 48.805 10.2557 51.6637 8.93802 54.1608C7.98794 55.9613 7.5129 56.8615 7.89431 57.5118C8.27575 58.162 9.12774 58.1829 10.8317 58.2243C14.2016 58.3064 16.4739 57.3509 18.2776 56.0208C19.3006 55.2666 19.8121 54.8893 20.1647 54.846C20.5172 54.8026 21.211 55.0884 22.5983 55.6598C23.8452 56.1733 25.293 56.4902 26.6212 56.5785C30.4785 56.835 34.5136 56.8355 38.3787 56.5785Z",
    fill: "url(#paint0_linear_653_3296)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_653_3296",
    x1: 32.5,
    y1: 6.77087,
    x2: 32.5,
    y2: 58.2292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssistantEmptyAvatar);
export default __webpack_public_path__ + "static/media/ai-assistant-empty-avatar.7e72bd456b285621d9a9911ed5af0d16.svg";
export { ForwardRef as ReactComponent };